/**
 * External dependencies
 */
import clsx from 'clsx';
import {  __, _x  } from '@wordpress/i18n';
import { useMemo } from '@wordpress/element';
import { useBlockProps,InnerBlocks } from '@wordpress/block-editor';
import classnames from 'classnames';
import './editor.scss';
import InsSettings from './settings.js';
import Controls from './controls.js';
import { VayuBlocksUniqueId } from "@vayu-blocks/global";
import { blurb_classic_template_1, blurb_classic_template_2, blurb_flipbox_template_1, blurb_flipbox_template_2  } from './blurbTemplates';

import {VayuBlockAdvanceStyle} from '@vayu-blocks/advance-panel/style.js';

import { useState, useEffect} from '@wordpress/element';

const Edit = (props) => {

  const {attributes, setAttributes, clientId, isSelected} = props;

  
	const { mergedStyles, handleMouseEnter, handleMouseLeave,hoverAnimationClass, responsiveClasses } = VayuBlockAdvanceStyle(attributes);
	
	const { id } = attributes;

	if ( ! id ) {
		  setAttributes( { id: clientId } );
	  }

    VayuBlocksUniqueId({ 
            setAttributes: setAttributes, 
            clientId: clientId
          });

            const omitBy = (object, condition) => (
            Object.fromEntries(
              Object.entries(object).filter(([key, value]) => !condition(value))
            )
			     );
              const Classes = classnames({
                    "th-hide-desktop": attributes.responsiveTogHideDesktop,
                    "th-hide-tablet": attributes.responsiveTogHideTablet,
                    "th-hide-mobile": attributes.responsiveTogHideMobile,     
                });


            const style = omitBy({
                ...mergedStyles
			        }, x => x?.includes?.( 'undefined' ));        

            const blockProps = useBlockProps({
                className: clsx('vayu_blocks_blrub_wrap', {
                    'is-blurb-classic': attributes.blurbLayout === 'classic',	
                    'is-blurb-flipbox': attributes.blurbLayout === 'flipbox',	
                },
                Classes,
                hoverAnimationClass,
                responsiveClasses
        ),
                style
            });

            const blurbBlockProps = {
              ...blockProps,
              onMouseEnter: handleMouseEnter,
              onMouseLeave: handleMouseLeave,
          };

    const { blurbLayout, chooseLayoutClassic, chooseLayoutFlipbox } = attributes;

    // Determine the correct template based on layout and chosen options
    const [selectedTemplate, setSelectedTemplate] = useState(blurb_classic_template_1);

useEffect(() => {
    if (blurbLayout === 'flipbox') {
        setSelectedTemplate(
            chooseLayoutFlipbox === 'flipbox1'
                ? blurb_flipbox_template_1
                : blurb_flipbox_template_2
        );
    } else if (blurbLayout === 'classic') {
        setSelectedTemplate(
            chooseLayoutClassic === 'classic1'
                ? blurb_classic_template_1
                : blurb_classic_template_2
        );
    } else {
        setSelectedTemplate(blurb_classic_template_1); // fallback
    }
}, [blurbLayout, chooseLayoutClassic, chooseLayoutFlipbox]);

  // Create a unique key for the InnerBlocks based on the layout selections
  const templateKey = `${blurbLayout}-${chooseLayoutClassic}-${chooseLayoutFlipbox}`;
//   const templateKey = selectedTemplate ? selectedTemplate.join(',') : 'default';

    return (
        <>
        {attributes.linkEnable && isSelected && (
            <Controls
                    attributes={ attributes }
                    setAttributes={ setAttributes }
                />
        )}
        {isSelected &&
            <InsSettings
                {...props}
            />
        }
                <div {...blurbBlockProps}>
                <div className='blurb-inner'>
                <InnerBlocks
                        key={templateKey} // Unique key based on layout and template choices
                        template={selectedTemplate}
                        templateLock="all"
                    />
                </div>
            </div>
        </>
    );
};

export default Edit;
